let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2c08y")).then(() => parcelRequire('4eAP9'));